import { useEffect, useContext, useRef } from 'react';
import BackendTable from 'react-backend-table';
import { KTSVG } from '../../_metronic/helpers';
import userPermissionContext from '../../context/userPermissionContext';

function ExpenseDt(props) {
	const { jwt } = useContext(userPermissionContext);
	const backendTableRef = useRef(null);
	let columns = [
		{ title: 'Id', field: 'idVmsExpenseTypes', sortable: true, searchable: true, thStyle: { textAlign: "center" }, tdStyle: { textAlign: "center" } },
		{ title: 'Expense Name', field: 'expenseName', sortable: true, searchable: true },
		{ title: 'Expense Head', field: 'headName', sortable: true, searchable: true },
		{ title: 'Ledger Name', field: 'ledgerName', sortable: true, searchable: true },
		{
			title: 'Status',
			field: 'status',
			sortable: true,
			searchable: true,
			thClass: "text-center",
			tdClass: "text-center",
			hasComponent: true,
			componentValue: ((rowValue) => {
				return (rowValue.status === "Active" ? <span className="badge badge-light-success fw-bolder">Active</span> : <span className="badge badge-light-danger fw-bolder">Inactive</span>)
			})
		},
		{
			title: "Action",
			field: "action",
			thStyle: { textAlign: "center" },
			tdClass: "text-center",
			tdStyle: { whiteSpace: 'nowrap' },
			sortable: false,
			searchable: false,
			hasComponent: true,
			componentValue: ((rowValue) => {
				return (<button className="btn btn-light-primary btn-sm" onClick={() => { props.onAction(rowValue.idVmsExpenseTypes) }}>
					<KTSVG
						path='/media/svg/icons/Communication/Write.svg'
						className='svg-icon-5 svg-icon'
					/>
					Edit</button>
				)
			})
		}
	]

	let options = {
		url: process.env.REACT_APP_API_URL + 'expenseList',
		authorization: 'Bearer ' + jwt.token,
		perPage: [5, 10, 30, 50, 'All'],
		orderBy: 'idVmsExpenseTypes',
		orderType: 'desc',
		columnSearch: true,
	}

	useEffect(() => {
		backendTableRef.current?.reload();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.addNewExpenseType, props.onCreate])
	return (
		<BackendTable ref={backendTableRef} columns={columns} options={options} />
	)
}

export default ExpenseDt